import { Clock, MapPin, Phone } from 'lucide-react';
import { FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import Reveal from '../components/animation/Reveal';
import PageFrame from '../components/layout/PageFrame';
import { businessDetails } from '../data/siteContent';

function ContactPage() {
  return (
    <PageFrame title="Contact" eyebrow="Visit or message">
      <Reveal className="contact-layout">
        <Reveal className="contact-panel" delay={0.04}>
          <h2>Tell us what you need stitched.</h2>
          <p>Share your dishdasha requirement, fabric preference, and fitting timeline. Harish (Anwar) will guide the next step for measurement and pricing.</p>
          <dl>
            <div>
              <dt><Phone size={18} /> Phone</dt>
              <dd>{businessDetails.manager}: {businessDetails.phone}</dd>
            </div>
            <div>
              <dt><MapPin size={18} /> Address</dt>
              <dd>{businessDetails.address}</dd>
            </div>
            <div>
              <dt><Clock size={18} /> Hours</dt>
              <dd>Saturday to Thursday, 10:00 AM to 9:00 PM</dd>
            </div>
          </dl>
          <a className="whatsapp-link" href={`https://wa.me/${businessDetails.phoneRaw}`}>
            <FaWhatsapp />
            Chat on WhatsApp
          </a>
          <div className="contact-socials">
            <span><FaInstagram /> {businessDetails.instagram}</span>
            <span><FaTiktok /> {businessDetails.tiktok}</span>
          </div>
        </Reveal>
      </Reveal>
      <div className="branch-grid">
        {businessDetails.branches.map((branch, index) => (
          <Reveal as="article" className="branch-card" key={branch.name} delay={index * 0.08}>
            <h2>{branch.name}</h2>
            <p>{branch.area}</p>
            <strong>{branch.phones}</strong>
          </Reveal>
        ))}
      </div>
    </PageFrame>
  );
}

export default ContactPage;
